import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
import { Label } from './Label'

const FormRow = ({
                         children,
                         className,
                       }: ChildrenProp & { className?: string }) => {
  return (
    <div
      className={cn(
        'text-sm font-semibold text-gray-700 py-4 border-b w-full border-gray-200 flex items-center justify-between',
        className
      )}
    >
      {children}
    </div>
  )
}

const FormRowLabel = ({ text }: {text:string}) => {
  return <Label text={text}/>
}

const FormRowValue = ({ text, className}: {text:string, className?: string}) => {
  return <div className={cn("font-normal break-words overflow-wrap-anywhere", className)}>{text}</div>
}

export { FormRow, FormRowLabel, FormRowValue }